import React from 'react';
import { searchArdOnline } from './services/apiService';

export function createArdOnlineSearchContext(value) {
  return {
    query: value.trim(),
  };
}

export async function performArdOnlineSearch(config, requestConfig, fromPos, searchContext) {
  const data = await searchArdOnline(config, requestConfig, fromPos, searchContext);

  return {
    data: data?.output?.documents || [],
    originalQuery: data?.output?.original_query || searchContext?.query,
    usedQuery: data?.output?.query || searchContext?.query,
    accordionInfo: null,
  };
}

export default function ArdOnlineSearch() {
  return null;
}